import { render, staticRenderFns } from "./site-target.vue?vue&type=template&id=55920e84&"
import script from "./site-target.vue?vue&type=script&lang=js&"
export * from "./site-target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports